var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button",class:{
  'button--alternative': _vm.alternative,
}},[_c(_vm.component,_vm._g(_vm._b({tag:"component",staticClass:"button__content animated pulse infinite",attrs:{"target":_vm.$attrs.to ? undefined : '_blank'}},'component',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }